export function formatStationDistanceMeters(meters: number): string {
  if (meters >= 1000) {
    const kilometres = meters / 1000;
    const rounded = kilometres >= 10 ? Math.round(kilometres) : Number(kilometres.toFixed(1));
    return `${rounded} km`;
  }

  return `${meters} m`;
}

export function humanizeAccommodationAttribute(code: string): string {
  return code
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
